import { CfeDocument, CfeTipoLabel } from '@/types/cfe';
import { normalizeCfeMessage } from '@/utils/cfeUtils';

type Props = {
  cfe: CfeDocument;
  showType?: boolean;
};

export default function CfeStatusBadge({ cfe, showType = true }: Props) {
  const getStatusInfo = () => {
    // Display the already stored remote text correctly before its next synchronization.
    const dgiStatus = cfe.dgi_estado === 'DESCONOCIDO' && cfe.dgi_estado_taface?.trim().toLowerCase() === 'aceptado o n/c'
      ? 'ACEPTADO_O_NC' : cfe.dgi_estado;
    const dgiLabels: Record<string, string> = {
      RECHAZADO: 'Rechazado por DGI', ANULADO: 'Anulado',
      RECHAZADO_O_ANULADO: 'Rechazado o anulado', ACEPTADO: 'Aceptado por DGI',
      ACEPTADO_O_NC: 'Aceptado o N/C',
      PENDIENTE: 'Pendiente de respuesta', DESCONOCIDO: 'Estado sin identificar',
    };
    if (dgiStatus && dgiLabels[dgiStatus]) {
      const rejected = ['RECHAZADO', 'ANULADO', 'RECHAZADO_O_ANULADO'].includes(dgiStatus);
      return { label: dgiLabels[dgiStatus], className: rejected
        ? 'bg-red-100 text-red-800 border-red-200'
        : dgiStatus === 'ACEPTADO' ? 'bg-green-100 text-green-800 border-green-200'
        : 'bg-yellow-100 text-yellow-800 border-yellow-200' };
    }
    if (normalizeCfeMessage(cfe.error_message)) {
      return { label: 'Error', className: 'bg-red-100 text-red-800 border-red-200' };
    }
    if (cfe.cfe_enviado) {
      return { label: 'Enviado · Sin verificar DGI', className: 'bg-yellow-100 text-yellow-800 border-yellow-200' };
    }
    if (cfe.cfe_confirmado) {
      return { label: 'Confirmado', className: 'bg-blue-100 text-blue-800 border-blue-200' };
    }
    if (cfe.cfe_firmado_ok) {
      return { label: 'Firmado', className: 'bg-yellow-100 text-yellow-800 border-yellow-200' };
    }
    return { label: 'Pendiente', className: 'bg-gray-100 text-gray-800 border-gray-200' };
  };

  const { label, className } = getStatusInfo();
  const tipoLabel = CfeTipoLabel[cfe.cfe_tipo_code] || `Tipo ${cfe.cfe_tipo_code}`;

  return (
    <span className="inline-flex items-center gap-1">
      {showType && (
        <span className="text-xs text-gray-500">{tipoLabel}</span>
      )}
      <span className={`px-2 py-0.5 text-xs font-medium rounded-full border ${className}`}>
        {label}
      </span>
    </span>
  );
}
